import {
  IConfigurationParams,
  ConfigurationNames,
} from '../../../../graphql/configuration/models/configuration.models';

export const getCaptchaEnabled = (configuration: IConfigurationParams[]): boolean => {
  const captchaParams = configuration.find((
    params,
  ) => params.name === ConfigurationNames.captcha);

  return captchaParams ? JSON.parse(captchaParams.configuration).enabled : false;
};
